import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export type AlertType = 'success' | 'info' | 'warning' | 'error';

export interface RouteAlert {
  message: string;
  type?: AlertType;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  constructor(private router: Router) {}

  setAlertOnNavigate(route: string, alert: RouteAlert, extras: any = {}): void {
    this.router.navigate([route], {
      ...extras,
      state: { ...extras.state, alertMessage: alert.message, alertType: alert.type || 'info' }
    });
  }

  getRouteAlert(): RouteAlert | null {
    const nav = this.router.getCurrentNavigation();
    if (!nav?.extras?.state?.['alertMessage']) return null;

    return {
      message: nav.extras.state?.['alertMessage'],
      type: nav.extras.state?.['alertType'] || 'info'
    };
  }
}
